import { render, staticRenderFns } from "./OrderViewDashboard.vue?vue&type=template&id=02ab6b20&scoped=true&"
import script from "./OrderViewDashboard.vue?vue&type=script&lang=js&"
export * from "./OrderViewDashboard.vue?vue&type=script&lang=js&"
import style0 from "./OrderViewDashboard.vue?vue&type=style&index=0&id=02ab6b20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ab6b20",
  null
  
)

export default component.exports